import React from 'react';
import { IProsperityComponent } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import AnimatedTitle from '../../components/AnimatedTitle';
import Img from '../../components/Img';
import styles from './CompanyMission.module.scss';

type CompanyMissionProps = {
  data: IProsperityComponent
};
const CompanyMission = ({ data }: CompanyMissionProps) => (
  <section className={classnames(styles.section, 'container')}>
    <div className={styles.column}>
      <h2 className={classnames(styles.title, 'title3')}>
        <AnimatedTitle
          title={data.title}
        />
      </h2>
      <div className={classnames(styles.photo, styles.photo_first)}>
        <Img
          src={data.image1.url}
          alt={data.image1.alternativeText || 'company mission image'}
          withPreloader
        />
      </div>
    </div>
    <div className={styles.column}>
      <p className={classnames(styles.text, 'bodyText')}>
        {data.description}
      </p>
      <div className={classnames(styles.photo, styles.photo_second)}>
        <Img
          src={data.image2.url}
          alt={data.image2.alternativeText || 'company mission image'}
          withPreloader
        />
      </div>
      <div className={styles.believe}>
        <p className={styles.believe__title}>We believe:</p>
        <div className={styles.believe__content}>
          <div className={styles.believeItemValue}>{data.equation.summand1}</div>
          <div className={styles.believeItemSymbol}>
            <svg>
              <use
                xlinkHref='/media/plus.svg#plusSVG'
                href='/media/plus.svg#plusSVG'
              />
            </svg>
          </div>
          <div className={styles.believeItemValue}>{data.equation.summand2}</div>
          <div className={styles.believeItemSymbol}>
            <svg>
              <use
                xlinkHref='/media/plus.svg#plusSVG'
                href='/media/plus.svg#plusSVG'
              />
            </svg>
          </div>
          <div className={styles.believeItemValue}>{data.equation.summand3}</div>
          <div className={styles.believeItemSymbol}>
            <svg>
              <use
                xlinkHref='/media/equal.svg#equalSVG'
                href='/media/equal.svg#equalSVG'
              />
            </svg>
          </div>
          <div className={styles.believeItemFinish}>{data.equation.result}</div>
        </div>
      </div>
    </div>
  </section>
);

export default CompanyMission;
